import UTopSDKPRO from "utopsdkjs";
import UTopSDKQA from "utopsdkjs-dev";

import getName from "./getName";
import { TRACKING_TYPE } from "./constant";
import AppConfigs from "configs/env";
const UTopSDK = AppConfigs.envUtopSDK === "qa" ? UTopSDKQA : UTopSDKPRO;
const requestButtonTracking = (button_id, button_name) => {
  try {
    UTopSDK.Tracking.logClick({
      button_id: button_id,
      button_name: button_name,
      page_location: window.location.href,
      service_id: "",
      custom_field: {
        fingerprint: "",
      },
      screen_name: "",
      screen_id: "",
    });
  } catch (error) {}
};

const setUserId = (idUser) => {
  try {
    UTopSDK.Tracking.setUserId(idUser);
  } catch (error) {}
};
const setAppId = (appId) => {
  try {
    UTopSDK.Tracking.setAppId(appId);
  } catch (error) {}
};
const logSignUp = (method) => {
  try {
    UTopSDK.Tracking.logSignUp({
      method: method,
      custom_field: {
        fingerprint: localStorage.getItem("fpAPIKey"),
      },
    });
  } catch (error) {}
};
const logLogIn = (method) => {
  try {
    UTopSDK.Tracking.logLogIn({
      method: method,
      custom_field: {
        fingerprint: localStorage.getItem("fpAPIKey"),
      },
    });
  } catch (error) {}
};
const logPageView = () => {
  let preUrl = localStorage.getItem("preUrl");
  localStorage.setItem("preUrl", window.location.href);
  try {
    UTopSDK.Tracking.logPageView({
      page_location: window.location.href,
      page_referrer: preUrl !== null ? preUrl : "",
      custom_field: {
        fingerprint: localStorage.getItem("fpAPIKey"),
      },
    });
  } catch (error) {}
};
const requestTracking = (type, data) => {
  switch (type) {
    case TRACKING_TYPE.BUTTON_TRACKING:
      requestButtonTracking(data);
      break;
    case TRACKING_TYPE.LOG_LOGIN:
      logLogIn(data);
      break;
    case TRACKING_TYPE.SET_USER_ID:
      setUserId(data);
      break;
    case TRACKING_TYPE.SET_APP_ID:
      setAppId(data);
      break;
    case TRACKING_TYPE.LOG_SIGN_UP:
      logSignUp(data);
      break;
    case TRACKING_TYPE.LOG_PAGEVIEW:
      logPageView();
      break;
    default:
      break;
  }
};

export {
  requestButtonTracking,
  setUserId,
  logSignUp,
  logLogIn,
  setAppId,
  logPageView,
  requestTracking,
};
